import api from "../utils/api";
import { S_SKU, webStorage } from "../utils/webStorage";
import { MathUtils } from "../utils";
export const initialLogic = async (lang, item) => {
  const res = await getSkuBySpuId(lang, item);
  console.log("initialLogic", res, lang, item);
  if (res && res.obj && res.obj.skuIdsList && res.obj.skuIdsList.length) {
    webStorage.set(S_SKU, res.obj.skuIdsList[0]);
    const { code, obj } = await getPrices(lang, res.obj.skuIdsList[0]);
    if (code !== "1") {
      return null;
    } else if (obj) {
      let currencySymbol = obj.currencySymbol ? obj.currencySymbol : "";
      let price = obj.price ? obj.price : 0;
      let msrp = obj.msrp ? obj.msrp : 0;
      let image = obj.skuImagesList ? obj.skuImagesList : [];
      return {
        currency: currencySymbol,
        formattedMsrp: MathUtils.priceFormat(msrp, lang),
        formattedPrice: MathUtils.priceFormat(price, lang),
        deposit: MathUtils.numbersPrice(price),
        image: image
      };
    }
  }
};
export const getSkuBySpuId = async (lang, summaryCommon) => {
  if (!summaryCommon?.shopspuId) {
    return;
  }
  const body = {
    spuId: summaryCommon.shopspuId
  };
  console.log(summaryCommon.color, summaryCommon.engine, "getSkuByspuId");
  if (
    (summaryCommon.color &&
      summaryCommon.color.preSelectValue &&
      summaryCommon.engine.preSelectValue.apiParentLabel) ||
    (summaryCommon.engine &&
      summaryCommon.engine.preSelectValue &&
      summaryCommon.engine.preSelectValue.apiParentLabel)
  ) {
    body.skuAttributeValueMap = {};
  }
  if (
    summaryCommon.color &&
    summaryCommon.color.preSelectValue &&
    summaryCommon.color.preSelectValue.apiParentLabel &&
    summaryCommon.color.preSelectValue.value
  ) {
    body.skuAttributeValueMap[
      summaryCommon.color.preSelectValue.apiParentLabel
    ] = summaryCommon.color.preSelectValue.value || "";
  }
  if (
    summaryCommon.engine &&
    summaryCommon.engine.preSelectValue &&
    summaryCommon.engine.preSelectValue.apiParentLabel &&
    summaryCommon.engine.preSelectValue.value
  ) {
    body.skuAttributeValueMap[
      summaryCommon.engine.preSelectValue.apiParentLabel
    ] = summaryCommon.engine.preSelectValue.value || "";
  }
  if (
    summaryCommon.financing &&
    summaryCommon.financing.preSelectValue &&
    summaryCommon.financing.preSelectValue.apiParentLabel &&
    summaryCommon.financing.preSelectValue.value
  ) {
    body.skuAttributeValueMap[
      summaryCommon.financing.preSelectValue.apiParentLabel
    ] = summaryCommon.financing.preSelectValue.value || "";
  }
  const res = await api.product.detail(null, body);
  return res;
};
export const getPrices = async (lang, val) => {
  const res = await api.product.sku.get({
    skuId: val
  });
  return res;
};
